export enum SectionType {
    home_page = 'home_page',
    library = 'library',
    gallery = 'gallery',
    activity = 'activity',
    calendar = 'calendar',
    notification_center = 'notification_center',
    store_list = 'store_list',
    quick_link = 'quick_link',
}

export enum SectionFilter {
    draft = 'draft',
    toBeReleased = 'toBeReleased',
    released = 'released',
    rejected = 'rejected',
    new = 'new',
    inProgress = 'inProgress',
    read = 'read',
    inApproval = 'inApproval',
    closed = 'closed',
    cancelled = 'cancelled',
    redo = 'redo',
    overdue = 'overdue',
    recalled = 'recalled',
    file = 'file',
    article = 'article',
    form = 'form',
}

export enum SectionQuery {
    sectionType = 'sectionType',
    sectionFilter = 'sectionFilter',
    both = 'both',
}

export interface GlobalSearchInput {
    search: string
    startDate?: number
    endDate?: number
    sectionType?: SectionType
    sectionFilter?: SectionFilter | string
    numElements?: string
}

export interface GlobalSearchOutput {
    sectionFilters?: SectionFilter[] | string[]
    [SectionType.library]?: string[]
    [SectionType.gallery]?: {
        title: string
        total_size?: number
    }[]
    [SectionType.activity]?: {
        list: {
            title: string
            id: string
            storeIdsList: string[]
        }[]
        total_size?: number
    }
    [SectionType.calendar]?: {
        list: {
            title: string
            id: string
            storeIdsList: string[]
        }[]
        total_size?: number
    }
    [SectionType.notification_center]?: {
        list: {
            title: string
        }[]
        total_size?: number
    }[]
    [SectionType.home_page]?: {
        list: {
            title: string
        }[]
        total_size?: number
    }[]
    [SectionType.store_list]?: {
        list: {
            title: string
        }[]
        total_size?: number
    }[]
    [SectionType.quick_link]?: {
        list: {
            title: string
        }[]
        total_size?: number
    }[]
}
